import styled from 'styled-components';

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
`;

export const ElementContainer = styled.div`
  display: flex;
  & > div {
    margin-right: 8px;
  }

  :not(:last-child) {
    margin-bottom: 14px;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;

export const GridElement = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ButtonContainer = styled.div`
  justify-self: flex-end;
`;
